import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import { Container } from "react-bootstrap";
import "react-vertical-timeline-component/style.min.css";
import factsetIcon from "../assets/factset-icon.jpeg"
import cornelltechIcon from "../assets/cornell-tech-icon.jpeg";
import cornelluniversityIcon from "../assets/cornell-university-icon.jpeg";
import trilliumtradingIcon from "../assets/trilliumtrading-icon.jpg";
import googleIcon from "../assets/googlelogo.png";
import ReactMarkdown from 'react-markdown';
import React from "react";

export const Experience = () => {

  const experiences = [
    {
      id: 1,
      position: "Software Engineering Intern, Health & Home Team",
      location: "Google LLC",
      date: "May 2026 – August 2026",
      description: "Architected a secure sandbox for LLM code execution with strict resource limits. Bypassed a 4MB gRPC bottleneck using shared storage with cryptographic token delegation. Developed an AI agent CLI for automated background orchestration. Engineered E2E distributed integration tests within CI/CD pipelines.",
      skills: "Docker, gRPC, CI/CD, Python, Cloud Storage",
      icon: googleIcon
    },
    {
      id: 2,
      position: "Machine Learning Undergraduate Researcher",
      location: "Cornell Tech",
      date: "June 2024 – Present",
      description: "Led research on human responses to repeated robot failures in the BAD Robots project. Extracted 66 features from 30+ videos to train multimodal time-series models with 93% accuracy. Published and presented two first-author papers at HRI '25 and NERC '25.",
      skills: "Python, TensorFlow, PyTorch, scikit-learn",
      icon: cornelltechIcon,
    },
    {
      id: 3,
      position: "Cybersecurity Engineering Intern",
      location: "FactSet Research Systems Inc.",
      date: "June 2025 – December 2025",
      description: "Built scalable cloud-native microservices and GraphQL APIs with RBAC. Engineered LLM-driven MCP tools with Python and Claude to interactively query vulnerabilities. Deployed a threat intelligence platform on AWS EKS using Kubernetes and Helm to automate data collection.",
      skills: "JavaScript, GraphQL, Azure, Python, AWS EKS, Kubernetes, Helm",
      icon: factsetIcon
    },
    {
      id: 4,
      position: "Software Engineering Intern",
      location: "Trillium Trading, LLC",
      date: "July 2022",
      description: "Engineered 6 high-performance Java simulators for stock-locate workflows to test latency-sensitive infrastructure. Built simulators leveraging FIX protocol and REST APIs. Implemented multithreaded processing for high-throughput conditions.",
      skills: "Java, FIX protocol, REST APIs, Multithreading",
      icon: trilliumtradingIcon,
    },
  ];

  return (
    <section className="experience-section" id="experience">
      <Container classname="experience-timeline">
        <div className="vertical-timeline-wrapper">
          <h2 className="section-title">Experience</h2>
          <VerticalTimeline className="vertical-timeline">
            {experiences.map((experience) => (
              <VerticalTimelineElement
                key={experience.id}
                date={experience.date}
                dateClassName="date"
                iconStyle={{ background: `url(${experience.icon})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat", border: "1px solid ", boxShadow: "0 0 0 5px #7aa8f9" }}
                iconClassName="vertical-timeline-element-icon"
                className="vertical-timeline-element"
                contentStyle={{ background: 'rgb(19, 81, 102)', color: '#fff', border: '4px solid #7aa8f9', borderRadius: '12px', boxShadow: '0 4px 20px rgba(89, 162, 241, 0.2)' }}
                contentArrowStyle={{ borderRight: '7px solid  #7aa8f9' }}
              >
                <div className="experience-box">
                  <h3 className="vertical-timeline-element-title text-white font-weight-bold">{experience.position}</h3>
                  <h5 className="vertical-timeline-element-subtitle" style={{color: '#90fff0'}}>{experience.location}</h5>
                  <ReactMarkdown
                    components={{
                      p: ({ node, ...props }) => (
                        <p className="vertical-timeline-element-description mt-3" {...props} style={{color: '#cfdffc'}} />
                      ),
                      a: ({ node, ...props }) => (
                        <a target="_blank" rel="noopener noreferrer" {...props} style={{color: '#90fff0'}} />
                      ),
                    }}
                  >
                    {experience.description}
                  </ReactMarkdown>
                  <div className="tech-tags mt-4">
                      {experience.skills.split(', ').map((skill, index) => (
                          <span className="tech-tag" key={index}>{skill}</span>
                      ))}
                  </div>
                </div>
              </VerticalTimelineElement>
            ))}
          </VerticalTimeline>
        </div>
      </Container>
    </section>
  )

}